import { useState } from "react";
import useAxiosInstance from "../Axios/hooks/useAxiosInstance";
import emailValidator from "../utils/emailValidator";
import { EMAIL_VALIDATE } from "../api/apiEndpoints";

const useValidateEmail = () => {
  const { axiosInstance } = useAxiosInstance();

  const [error, setError] = useState();
  const validateEmail = async (email, currentEmail = "") => {
    try {
      const emailValid = emailValidator(email);
      if (!emailValid) {
        setError("Please enter a valid email");
        return;
      }
      if (email === currentEmail) {
        setError("");
        return;
      }
      const res = await axiosInstance.get(
        EMAIL_VALIDATE,
        {
          headers: {
            email: email,
          },
        }
      );
      if (res.status === 200) {
        setError("");
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Unable to verify email. Please try again later.";
      setError(message);
    }
  };

  return {
    validateEmail,
    inValidEmailMessage: error,
    setInvalidEmail: setError,
  };
};
export default useValidateEmail;
